export default "__VITE_ASSET__BQkF9eP$__"